// extracted by mini-css-extract-plugin
module.exports = {"shapeTop":"Spacer_shapeTop__Xm3Kr","shape":"Spacer_shape__B3XeN","icon":"Spacer_icon__HA_t8"};